import { render, staticRenderFns } from "./appointmentTable.vue?vue&type=template&id=15aada19&scoped=true&"
import script from "./appointmentTable.vue?vue&type=script&lang=js&"
export * from "./appointmentTable.vue?vue&type=script&lang=js&"
import style0 from "./appointmentTable.vue?vue&type=style&index=0&id=15aada19&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aada19",
  null
  
)

export default component.exports